import { render, staticRenderFns } from "./ProfileInfoContacts.vue?vue&type=template&id=7a773fc8&scoped=true&"
import script from "./ProfileInfoContacts.vue?vue&type=script&lang=js&"
export * from "./ProfileInfoContacts.vue?vue&type=script&lang=js&"
import style0 from "./ProfileInfoContacts.vue?vue&type=style&index=0&id=7a773fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a773fc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a773fc8')) {
      api.createRecord('7a773fc8', component.options)
    } else {
      api.reload('7a773fc8', component.options)
    }
    module.hot.accept("./ProfileInfoContacts.vue?vue&type=template&id=7a773fc8&scoped=true&", function () {
      api.rerender('7a773fc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/ProfileInfoContacts.vue"
export default component.exports